import React from 'react';

export function stopClickThrough<E extends { stopPropagation: () => void; preventDefault: () => void }>(event: E) {
  event.stopPropagation();
  event.preventDefault();
}

export function isEventTargetTextInput(e: UIEvent) {
  const target = e.target as HTMLElement;
  return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}

export function isMouseEventLeftClick(e: MouseEvent | React.MouseEvent) {
  return e.button === 0;
}
